import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import DataTable from "react-data-table-component";
import ReactHtmlParser from "react-html-parser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../../config";

const Overtime = (props) => {
  const [table, setTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [originalOvertimeHour, setOriginalOvertimeHour] = useState("");

  /* ================= FETCH LIST ================= */
  useEffect(() => {
    loadOvertimeList();
  }, []);

  const loadOvertimeList = () => {
    setLoading(true);
    axios
      .get(API_BASE_URL + "/overtime_list", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        setTable(res.data.data.overtime_list || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  /* ================= FETCH OVERTIME ================= */
  const handleFetchOvertime = async () => {
    setLoading(true);
    try {
      await axios.post(
        API_BASE_URL + "/fetch_overtime",
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      toast.success("Overtime data fetched successfully");
      loadOvertimeList();
    } catch {
      toast.error("Failed to fetch overtime data");
    } finally {
      setLoading(false);
    }
  };

  /* ================= EDIT ================= */
  const handleEdit = async (overtime_id) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/edit_overtime/${overtime_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setEditData(res.data);
      setOriginalOvertimeHour(res.data.overtime_hour);
      setShowEditModal(true);
    } catch {
      toast.error("Failed to fetch overtime entry");
    }
  };

  const submitEdit = () => {
    if (editData.overtime_hour > originalOvertimeHour) {
      toast.error("You are not allowed to increase the Overtime Hour");
      return;
    }

    axios
      .post(
        API_BASE_URL + "/overtime_update",
        {
          overtime_id: editData.overtime_id,
          overtime_hour: editData.overtime_hour,
          status: editData.status,
          overtime_date: editData.overtime_date,
          reason: editData.reason,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          toast.success(res.data.message);
          setShowEditModal(false);
          loadOvertimeList();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => toast.error("Update failed"));
  };

  /* ================= SEARCH ================= */
  const filteredData = table.filter((item) =>
    `${item.name} ${item.emp_id}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  /* ================= DATATABLE COLUMNS ================= */
 const columns = [
  {
    name: "Action",
    cell: (row) =>
      row.is_applied != 1 ? (
        <button
          className="border-0 bg-transparent me-2"
          onClick={() => handleEdit(row.overtime_id)}
        >
          <i className="fa fa-pencil text-warning" style={{ fontSize: "18px" }}></i>
        </button>
      ) : null,
    minWidth: "60px",
  },
  { name: "Emp ID", selector: (row) => row.emp_id, sortable: true, minWidth: "120px" },
  { name: "Name", selector: (row) => row.name, sortable: true, minWidth: "180px" },
  { name: "Department", selector: (row) => row.department_name, minWidth: "180px" },
  { name: "Shift", selector: (row) => row.shift_name, minWidth: "150px" },
  { name: "OT Date", selector: (row) => row.overtime_date, sortable: true, minWidth: "150px" },
  { name: "Before Shift", selector: (row) => row.before_shift, minWidth: "140px" },
  { name: "After Shift", selector: (row) => row.after_shift, minWidth: "140px" },
  { name: "Total Work", selector: (row) => row.total_works, minWidth: "140px" },
  { name: "Total OT", selector: (row) => row.total_overtime, minWidth: "140px" },
  { name: "Status", selector: (row) => row.status, minWidth: "120px" },
  { name: "Updated On", selector: (row) => row.update_on, minWidth: "160px" },
  { name: "Reason", selector: (row) => row.reason, minWidth: "200px", wrap: true },
];

  return (
    <>
     <ToastContainer position="bottom-right" />

      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 style={{ color: "#e96827" }}>Overtime</h3>
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#e96827", color: "#fff" }}
            onClick={handleFetchOvertime}
          >
            + Fetch Overtime Data
          </button>
        </div>

        <div className="card">
         <div className="card-header">
  <div className="row align-items-center w-100">
    <div className="col-md-6">
      {/* <h4 className="mb-0">Overtime List</h4> */}
    </div>

    <div className="col-md-6 text-right">
      <input
        type="text"
        className="form-control form-control-sm float-right"
        style={{ width: "250px" }}
        placeholder="Search Employee"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>
  </div>
</div>


          <div className="card-body">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              highlightOnHover
              striped
              responsive
              progressPending={loading}
              noDataComponent="No overtime records found"
            />
          </div>
        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      {showEditModal && (
        <div className="modal fade show d-block overtime-modal">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Overtime Request</h5>
                <button className="close" onClick={() => setShowEditModal(false)}>
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <label>Overtime Date</label>
                    <div className="form-control bg-light">
                      {editData?.overtime_date}
                    </div>

                    <label className="mt-3">Total Hours</label>
                    <div className="form-control bg-light">
                      {editData?.total_work_hours}
                    </div>
                    <label className="mt-3">Shift Time</label>
<div className="readonly-box">
  <div className="fw-semibold">{editData?.shift_name}</div>
  <small className="text-success">
    {editData?.shift_time}
  </small>
</div>


                       <label className="mt-3">Punch In & Out</label>
  <div className="form-control bg-light">
    {editData?.punch_in} - {editData?.punch_out}
  </div>
                  </div>

                  <div className="col-md-6 required-tooltip">
                    <label>Status</label>
                    <select
                      className="form-control"
                      value={editData?.status || 2}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          status: parseInt(e.target.value),
                        })
                      }
                    >
                      <option value={2}>Request</option>
                      <option value={3}>Reject</option>
                    </select>

                    <label className="mt-3 ">Overtime Hour</label>
                    <input
                      className="form-control  required-input "
                      value={editData?.overtime_hour || ""}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          overtime_hour: e.target.value,
                        })
                      }
                    />

                     
                    

                    <label className="mt-3">
                      Reason 
                    </label>
                    <textarea
                      className="form-control required-input"
                      rows={3}
                      value={editData?.reason || ""}
                      onChange={(e) =>
                        setEditData({ ...editData, reason: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={submitEdit}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state) => ({
  fixNavbar: state.settings.isFixNavbar,
}))(Overtime);
